import { render, staticRenderFns } from "./Roadmap.vue?vue&type=template&id=02acf66a"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports